import React from 'react'
import { graphql, Link } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/layout';
import Activities from '../components/activities';
import * as d3 from 'd3';

export default class GiinTemplate extends React.Component {
  componentDidMount() {
    this.renderChart();
  }
  
  renderChart() {
    const { data } = this.props; 
    
    if(data.internalWordcloud) {
      const wordCounts = data.internalWordcloud.wordcloud.slice(0,30);
      const margin = {top: 10, right: 30, bottom: 40, left: 100},
            width = 640 - margin.left - margin.right,
            height = 700 - margin.top - margin.bottom;
  
      const svg = d3.select("#wordcount")
                    .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform",
                      "translate(" + margin.left + "," + margin.top + ")");
                      
      const x = d3.scaleLinear()
                  .domain([0, wordCounts[0].count + 10])
                  .range([ 0, width]);
      svg.append("g")
         .attr("transform", "translate(0," + height + ")")
         .call(d3.axisBottom(x))
         .selectAll("text")
         .attr("transform", "translate(-10,0)rotate(-45)")
         .style("text-anchor", "end")
         .style("font-size", "0.8rem");
  
      // Y axis
      const y = d3.scaleBand()
                  .range([ 0, height ])
                  .domain(wordCounts.map(function(d) { return d.word; }))
                  .padding(1);
      svg.append("g")
          .call(d3.axisLeft(y))
          .selectAll("text")
          .style("font-size", "0.8rem");
      // Lines
      svg.selectAll("myline")
          .data(wordCounts)
          .enter()
          .append("line")
          .attr("x1", function(d) { return x(d.count); })
          .attr("x2", x(0))
          .attr("y1", function(d) { return y(d.word); })
          .attr("y2", function(d) { return y(d.word); })
          .attr("stroke", "grey");
  
      // Circles
      svg.selectAll("mycircle")
          .data(wordCounts)
          .enter()
          .append("circle")
          .attr("cx", function(d) { return x(d.count); })
          .attr("cy", function(d) { return y(d.word); })
          .attr("r", "4")
          .style("fill", "#69b3a2")
          .attr("stroke", "black");
    }
  }
  
  render() {
    const { data } = this.props;
    const giin = data.giinsYaml;
    const groupNode = giin.groups ? data.allGroupsYaml.edges.find(({node}) => { return node.identifier === giin.groups[0].identifier }) : null;
    const group = groupNode ? groupNode.node : null;
    const partyNode = giin.parties ? data.allPartiesYaml.edges.find(({node}) => { return node.identifier === giin.parties[0].identifier }) : null;
    const party = partyNode ? partyNode.node : null;
    const identifier = giin.identifier;
    const bills = data.allBillsYaml ? data.allBillsYaml.edges : [];
    const submitters = bills.filter(({node}) => { return node.giins.submitters.includes(identifier); });
    const groupedSubmiters = submitters.reduce((acc, {node}) => {
      const found = giin.terms.find((term) => term.from <= node.submitted_at && node.submitted_at < term.to);
      const termId = `${found.from}.${found.to}`;
      acc[termId] = acc[termId] ? acc[termId] : [];
      acc[termId] = acc[termId].concat([node]);
      return acc;
    }, {});
    const proponents = bills.filter(({node}) => { return node.giins.proponents.includes(identifier); });
    const groupedProponents = proponents.reduce((acc, {node}) => {
      const found = giin.terms.find((term) => term.from <= node.submitted_at && node.submitted_at < term.to);
      const termId = `${found.from}.${found.to}`;
      acc[termId] = acc[termId] ? acc[termId] : [];
      acc[termId] = acc[termId].concat([node]);
      return acc;
    }, {});
    const petitions = data.allPetitionsYaml ? data.allPetitionsYaml.edges : [];
    const groupedPetitions = petitions.reduce((acc, {node}) => {
      const found = giin.terms.find((term) => term.from <= node.submitted_at && node.submitted_at < term.to);
      const termId = `${found.from}.${found.to}`;
      acc[termId] = acc[termId] ? acc[termId] : [];
      acc[termId] = acc[termId].concat([node]);
      return acc;
    }, {});
    const meetings = data.allMeetingsYaml ? data.allMeetingsYaml.edges : [];
    const groupedQuestions = meetings.reduce((acc, {node}) => {
      const found = giin.terms.find((term) => term.from <= node.convocation_date && node.convocation_date < term.to);
      const termId = `${found.from}.${found.to}`;
      const speaker = node.speakers.find(({identifier}) => { return identifier === giin.identifier; });
      acc[termId] = acc[termId] ? acc[termId] : [];
      acc[termId] = acc[termId].concat([{title: node.title, url: speaker.url}]);
      return acc;
    }, {});
    
    return (
      <Layout>
        <SEO
          title={giin.name}
          description={`${giin.name}の活動`}
        />
        <p>> <Link to={'/giins'}>一覧</Link> > {giin.name}</p>
        <h2>{giin.name}({giin.reading})</h2>
        <div>
          <table>
            <tbody>
              {
                giin.fields.current ? (<><th>現職</th><td></td></>) : null
              }
              <tr>
                <th>当選回数</th><td>{giin.numberOfElected}</td>
              </tr>
              <tr>
                <th>会派名</th>
                <td>
                  {
                    group ? <Link to={`/groups/${group.identifier}`}>{group.name}</Link> : '無所属'
                  }
                </td>
              </tr>
              <tr>
                <th>党派名</th>
                <td>
                  {
                    party ? party.name : '無所属'
                  }
                </td>
              </tr>
              <tr>
                <th>ホームページ</th><td><a href={giin.url} rel='noopener noreferrer' target='_blank'>{giin.url}</a></td>
              </tr>
            </tbody>
          </table>
        </div>
        {giin.terms.map((term, idx) => {
          const termId = `${term.from}.${term.to}`;
          const props = {
            term,
            petitions: groupedPetitions[termId] || [],
            questions: groupedQuestions[termId] || [],
            submitters: groupedSubmiters[termId] || [],
            proponents: groupedProponents[termId] || [],
          };
          return <Activities key={idx} {...props} />;
        })}
        <h3>議会でよく言及しているキーワード</h3>
        <p><small>※横にスクロールできます</small></p>
        <div id='wordcount'/>
        <div>
          <ul>
            <li>*1: 最大1年の任期中は、議長/副議長の場合は質問機会なし、監査委員の場合も議会で任命されてから満了するまでは質問をしない</li>
          </ul>
        </div>
      </Layout>
    )
  }
}

export const query = graphql`
  query($identifier: String!) {
    giinsYaml(identifier: { eq: $identifier }) {
      fields {
        current
      }
      identifier
      groups {
        from
        to
        identifier
      }
      name
      numberOfElected
      parties {
        from
        to
        identifier
      }
      reading
      url
      agreement_level
      terms {
        from
        to
      }
    }
    allBillsYaml(filter: { fields: { identifiers: { eq: $identifier } } }) {
      edges {
        node {
          title
          kind
          url
          giins {
            submitters
            proponents
          }
          submitted_at
        }
      }
    }
    allGroupsYaml {
      edges {
        node {
          identifier
          name
        }
      }
    }
    allPartiesYaml {
      edges {
        node {
          identifier
          name
        }
      }
    }
    allPetitionsYaml(filter: { fields: { identifiers: { eq: $identifier } } }) {
      edges {
        node {
          title
          url
          giins
          submitted_at
        }
      }
    }
    chairMeetings: allMeetingsYaml(filter: { chairman: { eq: $identifier } }) {
      edges {
        node {
          title
        }
      }
    }
    viceChairMeetings: allMeetingsYaml(filter: { viceChairman: { eq: $identifier } }) {
      edges {
        node {
          title
        }
      }
    }
    allMeetingsYaml(filter: { fields: { identifiers: { eq: $identifier } } }, sort: {order: DESC, fields: convocation_date}) {
      edges {
        node {
          title
          convocation_date
          speakers {
            identifier
            url
          }
        }
      }
    }
    internalWordcloud(identifier: { eq: $identifier }) {
      name
      identifier
      wordcloud {
        word
        count
      }
    }
  }
`;